import React from 'react';

import { useForm } from 'react-hook-form';
import { observer } from 'mobx-react';
import { Button, LbInput, LbSelect, Surface, InputAdornment } from '@infoods/lifebase-ui';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';

import classes from './FiltersRow.module.scss';
import { GridTableCell } from '../../../../../shared/components/table-components';
import { leaderboardStore } from '../../../../stores/leaderboardStore';
import { useAutoSubmitForm } from '../../../../../shared/hooks/useAutoSubmitForm';
import { genderOptionsWithAll } from '../../../../../shared/constants/user-info/gender';
import { addAllOption, transformToOptions } from '../../../../../shared/utils/arrayUtils';
import { AgeInput } from '../../../../../shared/components/form-components/AgeInput/AgeInput';
import { LeaderboardFilterValues } from '../../../../interfaces/leaderboard/LeaderboardListFilters';

const FiltersRow = observer(() => {
  const { filterMethods, challengeInfo } = leaderboardStore;
  const { applyFilters } = filterMethods;

  const { divisions } = challengeInfo || {};

  const { control, reset, watch, handleSubmit } = useForm<LeaderboardFilterValues>();

  const onSubmit = handleSubmit((data: LeaderboardFilterValues) => {
    applyFilters(data);
  });

  useAutoSubmitForm(onSubmit, watch, ['nickname', 'ageMin', 'ageMax']);

  const inputGeneralProps = { control, variant: 'outlined', size: 'small' } as const;

  const handleReset = () => {
    reset();
  };

  const divisionOptions = transformToOptions({
    list: divisions || [],
    valueKey: 'id',
    labelKey: 'name',
  });

  return (
    <Surface className={classes.filterRow}>
      <LbInput
        {...inputGeneralProps}
        name="nickname"
        placeholder="Leaderboard name"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <SearchRoundedIcon fontSize="large" color="tertiary" />
            </InputAdornment>
          ),
        }}
      />
      <LbSelect
        {...inputGeneralProps}
        label="Gender"
        name="gender"
        options={genderOptionsWithAll}
        displayEmpty
      />
      <AgeInput
        {...inputGeneralProps}
        startFieldProps={{ name: 'ageMin' }}
        endFieldProps={{ name: 'ageMax' }}
      />
      {divisionOptions.length ? (
        <LbSelect
          {...inputGeneralProps}
          label="Division"
          name="divisionId"
          options={addAllOption(divisionOptions)}
          displayEmpty
        />
      ) : (
        <div />
      )}
      <GridTableCell className={classes.clearAllButtonCell}>
        <Button variant="outlined" size="small" type="reset" onClick={handleReset}>
          Clear All
        </Button>
      </GridTableCell>
    </Surface>
  );
});

export { FiltersRow };
